var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-eyelet eyelet"},[_c('h4',{attrs:{"data-animation":_vm.isAnimated ? 'fade' : false}},[_vm._v("\n    "+_vm._s(_vm.data.content)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }